import { LISTING_STATUS_LABELS, listingStatusTone } from '../lib/marketplace';
import { ui } from '../lib/ui';

/** A marketplace listing's status as a pill (docs/Decisions.md D68). */
const TONE = {
  success: ui.pillSuccess,
  warning: ui.pillWarning,
  danger: ui.pillDanger,
  neutral: ui.pillNeutral,
};

export default function ListingPill({ status }) {
  return (
    <span className={TONE[listingStatusTone(status)]}>
      {LISTING_STATUS_LABELS[status] || status}
    </span>
  );
}
